import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconPlay = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <path d="M8.2,33.7c-0.8,0-1.5-0.2-2.2-0.6c-1.4-0.8-2.2-2.2-2.2-3.8V6.6c0-1.6,0.8-3,2.2-3.8c1.4-0.8,3-0.8,4.4,0L30,14.2
	c1.4,0.8,2.2,2.2,2.2,3.8c0,1.6-0.8,3-2.2,3.8v0L10.4,33.2C9.7,33.5,8.9,33.7,8.2,33.7z M8.2,4.6c-0.4,0-0.7,0.1-1,0.3
	c-0.6,0.4-1,1-1,1.8v22.7c0,0.7,0.4,1.4,1,1.8c0.6,0.4,1.4,0.4,2,0l19.7-11.4c0.6-0.4,1-1,1-1.8c0-0.7-0.4-1.4-1-1.8L9.2,4.9
	C8.9,4.7,8.5,4.6,8.2,4.6z"/>
    </SvgIcon>
  );
};

IconPlay.displayName = 'IconPlay';
IconPlay.muiName = 'SvgIcon';

export default IconPlay;



// WEBPACK FOOTER //
// ./src/components/Icons/IconPlay.js